module.exports = __webpack_public_path__ + "static/media/Pin-Dark-Delegacia.ee5f2264.svg";